<template>
  <div class="dateQuickCom">
    <el-date-picker
      v-model="dateData"
      :type="type"
      size="mini"
      style="margin-right: 10px"
      :format="typeParms[type]"
      :value-format="typeParms[type]"
      :picker-options="pickerOptions"
      :clearable="false"
    >
    </el-date-picker>
    <template
      v-if="
        $route.path == '/distributingRun' || $route.path == '/demandAnalysis'
      "
    >
      <span>设备</span>
      <el-select
        v-model="activeDevices"
        size="mini"
        @change="getDeviceParameter"
      >
        <el-option
          v-for="item in devicesList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <span>参数</span>
      <el-select v-model="activeParameter" size="mini" value-key="name">
        <el-option
          v-for="item in parameterList"
          :key="item.name"
          :label="item.name"
          :value="item"
        >
        </el-option>
      </el-select>
    </template>

    <template v-if="selectAsset.treeValue === 'Harmonic'">
      <span>谐波含量</span>
      <el-cascader
        ref="cascaderTree"
        style="margin: 0 10px"
        size="mini"
        v-model="harmonicParams"
        :options="selectAsset.harmonicParameter"
        :props="{
          value: 'key',
          label: 'name',
        }"
      ></el-cascader>
    </template>

    <el-button size="mini" @click="getDay('previous')">{{
      type == "date" ? "上一日" : type == "month" ? "上一月" : "上一年"
    }}</el-button>
    <el-button size="mini" :disabled="nextDisabled" @click="getDay('next')">{{
      type == "date" ? "下一日" : type == "month" ? "下一月" : "下一年"
    }}</el-button>
    <el-button size="mini" @click="submit">查询</el-button>
  </div>
</template>

<script>
import api from "@/api";
import { dateFtt } from "@/assets/js/utils";
export default {
  props: {
    type: {
      type: String,
      default: "date",
    },
    selectAsset: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dateData: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      typeParms: {
        date: "yyyy-MM-dd",
        month: "yyyy-MM",
        year: "yyyy",
      },
      devicesList: [],
      activeDevices: "",
      parameterList: [],
      activeParameter: {},
      harmonicParams: [],
    };
  },
  computed: {
    nextDisabled() {
      return dateFtt(this.typeParms[this.type], new Date()) == this.dateData;
    },
  },
  watch: {
    selectAsset: {
      handler() {
        if (this.selectAsset?.id) {
          /***** 配电系统中功能**** */
          if (
            this.$route.path == "/distributingRun" ||
            this.$route.path == "/demandAnalysis"
          ) {
            this.devicesList = [];
            this.activeDevices = "";
            this.parameterList = [];
            this.activeParameter = {};
            this.getDevicesList();
          } else if (this.$route.path == "/powerQuality") {
            if (this.selectAsset.treeValue === "Harmonic") {
              this.handlerHarmonicParams();
            } else {
              this.submit();
            }
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    getDate() {
      this.dateData = dateFtt(this.typeParms[this.type], new Date());
    },
    getDay(type) {
      let date = "";
      let moment = this.$moment(this.dateData);
      if (type == "next") {
        date = moment.add(
          "1",
          this.type == "date" ? "d" : this.type == "month" ? "M" : "y"
        );
      } else {
        date = moment.subtract(
          "1",
          this.type == "date" ? "d" : this.type == "month" ? "M" : "y"
        );
      }
      this.dateData = dateFtt(this.typeParms[this.type], new Date(date));
    },
    /***********     配电系统中功能     ******* */
    async getDevicesList() {
      let res = await api.getDeviceLisy({
        assetId: this.selectAsset.id,
      });
      if (res && res.status == 200) {
        this.devicesList = Array.from(res.data).map((v) => ({
          name: v.name,
          id: v.id.id,
          label: v.label,
          type: v.type,
        }));
        this.activeDevices = this.devicesList.length
          ? this.devicesList[0].id
          : "";
        if (this.activeDevices) {
          this.getDeviceParameter();
        } else {
          this.$message.warning("该资产下无设备");
        }
      }
    },
    async getDeviceParameter() {
      let res = await api.PDSGetDeviceParameter({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        deviceId: this.activeDevices,
        keyName: "KeyAndNameAndTypes",
      });
      if (res && res.data.code == 200) {
        this.parameterList = res.data.data;
        this.activeParameter = this.parameterList.length
          ? this.parameterList[0]
          : {};
        this.submit();
      }
    },
    handlerHarmonicParams() {
      this.harmonicParams = [];
      if (this.selectAsset.harmonicParameter[0]?.children) {
        this.harmonicParams = [
          this.selectAsset.harmonicParameter[0].key,
          this.selectAsset.harmonicParameter[0].children[0].key,
        ];
      }
      this.submit();
    },
    submit() {
      // 配电系统-运行状态、需量分析
      if (
        this.$route.path == "/distributingRun" ||
        this.$route.path == "/demandAnalysis"
      ) {
        if (!this.activeParameter.name) {
          this.$message.warning("请选择参数");
          return;
        }
        if (!this.activeDevices) {
          this.$message.warning("请选择设备");
          return;
        }
        this.$emit("getDateData", {
          timeType: this.type,
          timeValue: this.dateData,
          activeDevices: this.activeDevices,
          activeParameter: this.activeParameter,
        });
      } else {
        if (
          this.$route.path == "/powerQuality" &&
          this.selectAsset.treeValue === "Harmonic"
        ) {
          if (this.harmonicParams.length !== 2) {
            this.$message.warning("请选择谐波含量");
            return;
          }
          this.$emit("getDateData", {
            timeType: this.type,
            timeValue: this.dateData,
            key: this.harmonicParams[1],
          });
        } else {
          this.$emit("getDateData", {
            timeType: this.type,
            timeValue: this.dateData,
          });
        }
      }
    },
  },
  created() {
    this.getDate();
    if (
      this.$route.path !== "/distributingRun" &&
      this.$route.path !== "/demandAnalysis" &&
      this.$route.path !== "/powerQuality"
    ) {
      this.submit();
    }
  },
};
</script>

<style lang="scss" scoped>
.dateQuickCom {
  @include setFlexStart;
  .el-date-editor {
    width: 150px;
  }
  .el-select {
    width: 150px;
    margin: 0 10px;
  }
}
</style>
